import React, { Component } from 'react'

import ExampleComponent from 'react-preview-carousel'

export default class App extends Component {
  render () {
    return (
      <div>
        <ExampleComponent text='Modern React component module' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js